import React from 'react'

const TrackOrders = () => {
  return (
    <div>Login to track your orders or items... Thank you</div>
  )
}

export default TrackOrders;